






























import { ComponentDocumentation } from "@/api/ComponentDocumentation";
import { VueConstructor } from "vue/types/vue";
import { Route } from "vue-router";
import { Example } from "@/pages";
import Vue from "vue";
export default Vue.extend({
  props: {
    title: String,
    showApiOnly: Boolean
  },
  data() {
    return {
      relatedComponents: [] as Array<VueConstructor<any>>
    };
  },
  methods: {
    keyForExample(example: Example): string {
      return `example-${example.code}-${example.id}`;
    },
    keyForComponentDocumentation(
      documentation: ComponentDocumentation
    ): string {
      return `api-${documentation.componentName}`;
    },
    resetUI() {
      this.relatedComponents = [];
    }
  },

  computed: {
    examples(): Example[] {
      const { slug } = this.route.params;
      return this.$docLoader.examplesForPageWithSlug(slug);
    },
    route(): Route {
      return this.$route;
    },
    documentedComponents(): ComponentDocumentation[] {
      const { slug } = this.route.params;
      const documentation = this.$docLoader.relatedComponentDocumentationForPageWithSlug(
        slug
      );
      return documentation;
    }
  }
});
